import { ReportSummaryConfigBase } from "../../summary/types";

export const Summary: ReportSummaryConfigBase[] = [
  {
    label: "Number of Rows",
    fields: ["row_count"],
    type: ["COUNT"],
  }
];
